// Get settings

module.exports = {

	methods: {
		getCdn: function() {
			return window.appSettings.cdnUrl
		},

		getUrlNoCDN: function() {
			return window.appSettings.getUrl();
		},

		getWGUrl: function() {
			return window.appSettings.getWGUrl();
		},

	}
	
};


// WEBPACK FOOTER //
// ./client/mixins/settings.js